// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/NotificationsBadge/NotificationsBadge.less
// module id = 1012
// module chunks = 0